// @flow
import React, { Component } from "react";
import styled from "styled-components";
import { lighten } from "polished";

import RoundedSection from "./RoundedSection";

const BypassContainer = styled.div`
	font-size: 20px;
`;

let bypass_background = "#4da657";
const InnerBypassContainer = styled.div`
	background-color: ${lighten(0.25, bypass_background)};
	border-radius: 10px;
	font-size: 20px;
	margin-top: 15px;
	padding: 20px;
`;

const CodeContainer = styled.div`
	background-color: ${lighten(0.35, bypass_background)};
	display: flex;
	flex-direction: column;
	font-family: "Roboto Condensed", sans-serif;
	font-size: 30px;
	text-align: center;
	text-transform: uppercase;
`;

const CodeInput = styled.input`
	border: none;
	font-family: "Roboto Condensed", sans-serif;
	font-size: 30px;
	padding: 10px;
	text-align: center;
	text-transform: uppercase;
`;

type State = {
	code: string,
	completed: boolean,
};

type Props = {
	onCorrectCode: Function,
	heading: string,
	codeHeading?: string,
};

class CodeChecker extends Component<Props, State> {
	state = {
		code: this.generateCode(),
		completed: false,
	};

	// Generates a string that the user must type to unlock a site
	generateCode() {
		var chars =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		var randomString = "";
		for (var i = 0; i < 7; i++) {
			randomString += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return randomString.toUpperCase();
	}
	// Check if the user has entered the correct code
	handleCodeInputChange = (event: any) => {
		let code_input_value = event.target.value;
		if (code_input_value.toUpperCase() === this.state.code) {
			if (this.state.completed === false) {
				this.setState({
					completed: true,
				});

				this.props.onCorrectCode();
			}
		}
	};

	render() {
		return (
			<RoundedSection>
				<BypassContainer>
					<div>{this.props.heading}</div>
					<InnerBypassContainer>
						<div style={{ marginBottom: 10 }}>
							{this.props.codeHeading || "Type the code below:"}
						</div>

						<CodeContainer>
							<div style={{ padding: 10 }}>{this.state.code}</div>
							<CodeInput
								type="text"
								placeholder="Type code here"
								disabled={this.state.completed}
								maxLength={7}
								onKeyUp={this.handleCodeInputChange}
							/>
						</CodeContainer>
					</InnerBypassContainer>
				</BypassContainer>
			</RoundedSection>
		);
	}
}

export default CodeChecker;



// WEBPACK FOOTER //
// ../shared/components/CodeChecker.js